import { Objective } from "@models/objective.model"
import { ObjectiveList } from "@models/objectiveList.model"
import { proxy } from "valtio"
import {PopulationSegment} from "@models/populationSegment.model.ts";
import { KeyDate } from "@models/keyDate.model"
import { DropdownOption } from "./components/objectives/components/metrics/MetricItemDropdown"

export const scopeStore = proxy<{
    selectedObjectiveId: number,
    selectedObjective: Objective,
    objectivesList: ObjectiveList[],
    populationSegmentList: PopulationSegment[],
    listTypeChoices: DropdownOption[],
    keyDateToEdit: KeyDate | null
}>({
    selectedObjectiveId: -1,
    selectedObjective: new Objective(),
    objectivesList: [],
    populationSegmentList: [],
    listTypeChoices: [],
    keyDateToEdit: null
})
